(() => {
  if (customElements.get('oilogic-sticky-add-to-cart')) return;

// <oilogic-sticky-add-to-cart> — floating bar shown once the main buy buttons scroll out of view.
class OilogicStickyAddToCart extends HTMLElement {
  #ctrl = new AbortController();
  #buyButtonsObserver = null;
  #footerObserver = null;
  #hiddenByFooter = false;

  connectedCallback() {
    this.bar = this.querySelector('.sticky-add-to-cart__bar');
    this.submitButton = this.querySelector('[data-submit-button]');
    if (!this.bar || !this.submitButton) return;

    const { signal } = this.#ctrl;
    this.submitButton.addEventListener('click', this.handleClick, { signal });
    document.addEventListener('oilogic:cart:added', this.handleCartSettled, { signal });
    document.addEventListener('oilogic:cart:error', this.handleCartSettled, { signal });

    this.#observeBuyButtons();
    this.#observeFooter();
  }

  disconnectedCallback() {
    this.#ctrl.abort();
    this.#buyButtonsObserver?.disconnect();
    this.#footerObserver?.disconnect();
    clearTimeout(this.addedTimer);
  }

  #observeBuyButtons() {
    const buyButtons = document.querySelector('.product-buy');
    if (!buyButtons) return;

    this.#buyButtonsObserver = new IntersectionObserver(([entry]) => {
      if (!entry) return;
      const scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      if (scrolledPast) {
        this.#hiddenByFooter = false;
        this.show();
      } else if (entry.isIntersecting) {
        this.hide();
      }
    });
    this.#buyButtonsObserver.observe(buyButtons);
  }

  #observeFooter() {
    const footer = document.querySelector('footer.section--footer');
    if (!footer) return;

    this.#footerObserver = new IntersectionObserver(
      ([entry]) => {
        if (!entry) return;
        if (entry.isIntersecting) {
          this.#hiddenByFooter = true;
          this.hide();
        } else if (this.#hiddenByFooter) {
          this.#hiddenByFooter = false;
          this.show();
        }
      },
      { rootMargin: '200px 0px 0px 0px' }
    );
    this.#footerObserver.observe(footer);
  }

  show() {
    this.bar.dataset.stuck = 'true';
  }

  hide() {
    this.bar.dataset.stuck = 'false';
  }

  handleClick = () => {
    const mainSubmitButton = document.querySelector('.product-buy__submit');
    if (!mainSubmitButton) return;
    clearTimeout(this.addedTimer);
    delete this.submitButton.dataset.added;
    this.submitButton.disabled = true;
    this.submitButton.dataset.loading = '';
    mainSubmitButton.click();
  };

  handleCartSettled = (event) => {
    delete this.submitButton.dataset.loading;
    this.submitButton.disabled = false;

    if (event.type === 'oilogic:cart:added') {
      this.submitButton.dataset.added = '';
      clearTimeout(this.addedTimer);
      this.addedTimer = setTimeout(() => delete this.submitButton.dataset.added, 1500);
    }
  };
}

customElements.define('oilogic-sticky-add-to-cart', OilogicStickyAddToCart);
})();
